import { useContext, useEffect, useState } from 'react';
import { cacheServiceContext } from '../services';

export type StatusMetrics = {
  casperNetworkVersion: string;
  casperNetworkCommit: string;
  casperLiveVersion: string;
  casperLiveCommit: string;
  blockHeight: number;
  blockHeightTimestamp: string;
};

export type GetStatusMetrics = {
  data: StatusMetrics | null;
  loading: boolean;
};
export const useGetStatusMetrics = (): GetStatusMetrics => {
  const [data, setData] = useState<StatusMetrics | null>(null);

  const { getGlobalState } = useContext(cacheServiceContext);
  const { data: status } = getGlobalState('status');

  useEffect(() => {
    if (status == null) {
      return;
    }
    const [casperNetworkVersion, casperNetworkCommit] = (
      status.build_version || ''
    ).split('-');

    const blockHeight = status?.last_added_block?.height || 0;
    const blockHeightTimestamp = status?.last_added_block?.timestamp || '';

    const casperLiveVersion = import.meta.env.VITE_VERSION || '';
    const casperLiveCommit = import.meta.env.VITE_GIT_HASH || '';

    const statusMetrics = {
      casperNetworkVersion,
      casperNetworkCommit,
      blockHeight,
      blockHeightTimestamp,
      casperLiveVersion,
      casperLiveCommit,
    };

    setData(statusMetrics);
  }, [status]);

  return { data, loading: status == null };
};
